// src/components/profile-detail/ErrorState.jsx
import React from "react";
import { 
  Container, 
  Alert, 
  Button, 
  Box,
  Typography 
} from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const ErrorState = ({ id, navigate, theme }) => {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          p: { xs: 3, md: 4 },
          borderRadius: 3,
          backgroundColor: theme.palette.primary.alpha['10'],
          border: theme.custom.borders.medium,
          transition: 'all 0.3s ease',
          '&:hover': {
            backgroundColor: theme.palette.secondary.alpha['10']
          }
        }}
      >
        {/* Error Icon */}
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            backgroundColor: theme.palette.error.alpha['20'],
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 3,
            border: theme.custom.borders.medium,
            transition: 'all 0.3s ease',
            '&:hover': {
              backgroundColor: theme.palette.error.alpha['30'],
              transform: 'scale(1.05)'
            }
          }}
        >
          <ErrorOutlineIcon 
            sx={{ 
              fontSize: 40,
              color: theme.palette.error.light
            }} 
          />
        </Box>

        {/* Error Message */}
        <Typography 
          variant="h5" 
          color={theme.palette.text.primary} 
          sx={{ 
            fontWeight: 700,
            mb: 2 
          }}
        >
          Profile Not Found
        </Typography>

        <Typography 
          variant="body1" 
          color={theme.palette.text.secondary}
          sx={{ 
            mb: 3,
            maxWidth: 500 
          }}
        >
          The profile with ID <strong>"{id}"</strong> could not be found. 
          It may have been removed or the ID might be incorrect.
        </Typography>

        {/* Back Button */}
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
          sx={{ 
            color: theme.palette.primary.light,
            backgroundColor: theme.palette.primary.alpha['20'],
            border: theme.custom.borders.medium,
            borderRadius: 2,
            px: 4,
            py: 1.5,
            fontWeight: 600,
            fontSize: '1rem',
            transition: 'all 0.3s ease',
            '&:hover': {
              backgroundColor: theme.palette.secondary.alpha['30'],
              transform: 'translateY(-2px)',
              boxShadow: theme.shadows[4]
            }
          }}
        >
          Back to Profiles
        </Button>

        {/* Additional Help Text */}
        <Typography 
          variant="caption" 
          color={theme.palette.text.secondary}
          sx={{ 
            mt: 3,
            display: 'block' 
          }}
        >
          If you believe this is an error, please contact support
        </Typography>
      </Box>

      {/* Alternative Alert Style (Optional) */}
      {/* <Alert 
        severity="error" 
        sx={{ 
          mb: 3,
          borderRadius: 2,
          fontSize: '1rem',
          backgroundColor: theme.palette.error.alpha['10'],
          border: theme.custom.borders.medium,
          color: theme.palette.error.light,
          '& .MuiAlert-icon': {
            color: theme.palette.error.light
          }
        }}
      >
        Profile with ID "{id}" not found.
      </Alert> */}
    </Container>
  );
};

export default ErrorState;